import React, { lazy } from 'react'
import type { RouteObject } from 'react-router'

const Browse = lazy(() => import('./Browse'))
const Detail = lazy(() => import('./Detail'))

const routes: RouteObject[] = [
    {
        path: '/consultations',
        element: <Browse />
    },
    {
        path: '/consultations/details/:consultationId',
        element: <Detail />
    }
]

export default routes
